import { useMemo } from 'react'

import { generateRandomId } from '@app/services/random/generateRandomId'

export const useId = (defaultId?: string, enabled = true) => {
  return useMemo(
    () => (enabled ? defaultId || generateRandomId() : undefined),
    [defaultId, enabled]
  )
}
